export const LAYOUT_DIR = {
  LEFT: 'left',
  RIGHT: 'right',
  // TOP: 'top',
  // BOTTOM: 'bottom',
} as const;

export type LAYOUT_DIR_KEY = keyof typeof LAYOUT_DIR;
export type LAYOUT_DIR_VALUE = typeof LAYOUT_DIR[LAYOUT_DIR_KEY];

export const LAYOUT_MAP = {
  [LAYOUT_DIR.LEFT]: '왼쪽',
  [LAYOUT_DIR.RIGHT]: '오른쪽',
};

export const layoutDirList = Object.keys(LAYOUT_MAP).map((key) => {
  return {
    key: key,
    value: LAYOUT_MAP[key],
  };
});
